import { useCallback } from 'react';

import { usePostProfileReportMutation } from 'src/graphql/Mutations/postProfileReport.generated';
import type { ReportProfileReason } from 'src/types/generated';

export const useSubmitProfileReport = () => {
  const [postProfileReportMutation] = usePostProfileReportMutation();

  const submitProfileReport = useCallback(
    async (reason: string, comment: string, profileSlug: string) => {
      const { errors } = await postProfileReportMutation({
        variables: {
          input: {
            reason: reason as ReportProfileReason,
            comment,
            profileSlug,
          },
        },
      });

      if (errors) {
        return false;
      }
      return true;
    },
    [postProfileReportMutation],
  );

  return { submitProfileReport };
};
